export default class ContentsCounter {
  constructor (target) {
    this.target = target
    this.singularText = target.dataset.filtersCounterSingular
    this.pluralText = target.dataset.filtersCounterPlural
    this.noneText = target.dataset.filtersCounterNone
  }

  render (count) {
    if (count === 1) {
      this.target.textContent = this.singularText
    } else if (count > 1) {
      this.target.textContent = this.pluralText.replace('%{counter}', count)
    } else {
      this.target.textContent = this.noneText
    }
  }
}
